import { NgModule } from "@angular/core";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { LoadingMaskModule } from "@component/loadingmask/loadingmask.module";
import { CommunicationStateUpdaterInterceptor } from "./communication-state-updater-interceptor";
import { ReduxModule } from "../../../core/redux/redux.module";
import { AuthRequestInterceptor } from "./auth-request.interceptor";
import { SessionHttpInterceptor } from "./session.http.interceptor";

@NgModule({
    imports: [
        HttpClientModule,
        LoadingMaskModule,
        ReduxModule
    ],
    providers: [
        {
          provide: HTTP_INTERCEPTORS,
          useClass: AuthRequestInterceptor,
          multi: true
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: CommunicationStateUpdaterInterceptor,
          multi: true
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: SessionHttpInterceptor,
          multi: true
        }
    ]
})
class HttpInterceptorsModule {}

export {
  HttpInterceptorsModule,
  CommunicationStateUpdaterInterceptor,
  AuthRequestInterceptor,
  SessionHttpInterceptor
};
